var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs',{attrs:{"tabs":_vm.tabsFiltered,"entity-type":_vm.entityType,"entity-id":_vm.entityId}})}
var staticRenderFns = []

export { render, staticRenderFns }